import { render } from "./MiniStatisticsCard.vue?vue&type=template&id=be1ca034&scoped=true"
import script from "./MiniStatisticsCard.vue?vue&type=script&lang=js"
export * from "./MiniStatisticsCard.vue?vue&type=script&lang=js"

import "./MiniStatisticsCard.vue?vue&type=style&index=0&id=be1ca034&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be1ca034"]])

export default __exports__